import { render, staticRenderFns } from "./productFormItem.vue?vue&type=template&id=7682133e&scoped=true"
import script from "./productFormItem.vue?vue&type=script&lang=js"
export * from "./productFormItem.vue?vue&type=script&lang=js"
import style0 from "./productFormItem.vue?vue&type=style&index=0&id=7682133e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7682133e",
  null
  
)

export default component.exports